import { render } from "./Scheme.vue?vue&type=template&id=a462fd90&scoped=true"
import script from "./Scheme.vue?vue&type=script&lang=ts"
export * from "./Scheme.vue?vue&type=script&lang=ts"

import "./Scheme.vue?vue&type=style&index=0&id=a462fd90&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a462fd90"

export default script